module.exports = __webpack_public_path__ + "Body_feathers_MetalRoughness.f0fa8e9.basis";